// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__KW9FB","rodape__icone":"Rodape_rodape__icone__MX0CB"};